module.exports = __webpack_public_path__ + "static/media/icon-universal.9755bf80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-universal.svg
// module id = 559
// module chunks = 0